// Validation logic was requested by the buhl team
// See https://deltra.atlassian.net/browse/BA-3286?focusedCommentId=38007
export default function validatePhoneNumber(value: string): boolean {
  let firstChar = ''
  let valid = false
  for (let i = 0; i < value.length; i++) {
    if (i === 0) {
      firstChar = value.charAt(i)
    }
    if (firstChar !== value.charAt(i)) {
      valid = true
    }
  }

  // Sonderzeichen ersetzen
  value = value.replace(new RegExp(' ', 'g'), '')
  value = value.replace(new RegExp('[+()/-]', 'g'), '')

  if (value.length > 5 && !isNaN(Number(value)) && value !== '123456' && valid === true) {
    return true
  } else {
    return false
  }
}
